// extracted by mini-css-extract-plugin
export default {"container":"HelpPanel_container__tvV+O","overlapIndicator":"HelpPanel_overlapIndicator__DHyaa"};